import { render } from "./ColorsView.vue?vue&type=template&id=645c57d6&scoped=true"
import script from "./ColorsView.vue?vue&type=script&lang=js"
export * from "./ColorsView.vue?vue&type=script&lang=js"

import "./ColorsView.vue?vue&type=style&index=0&id=645c57d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645c57d6"]])

export default __exports__